import { useMemo } from 'react'

export function Sparkline({ data, color = 'currentColor', height = 24, fill = true }: {
  data: number[]; color?: string; height?: number; fill?: boolean
}) {
  const w = 100, h = 24
  const path = useMemo(() => {
    if (!data || data.length < 2) return { line: '', fill: '' }
    const min = Math.min(...data), max = Math.max(...data)
    const range = max - min || 1
    const step = w / (data.length - 1)
    const points = data.map((v, i) => [i * step, h - ((v - min) / range) * (h - 4) - 2] as const)
    const line = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(' ')
    const fillPath = `${line} L ${w} ${h} L 0 ${h} Z`
    return { line, fill: fillPath }
  }, [data])
  return (
    <svg className="spark" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" style={{ height, color }}>
      {fill && <path className="fill" d={path.fill} />}
      <path className="line" d={path.line} />
    </svg>
  )
}
